import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=080b9b94&scoped=true&"
import script from "./loginForm.vue?vue&type=script&lang=js&"
export * from "./loginForm.vue?vue&type=script&lang=js&"
import style0 from "./loginForm.vue?vue&type=style&index=0&id=080b9b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b9b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080b9b94')) {
      api.createRecord('080b9b94', component.options)
    } else {
      api.reload('080b9b94', component.options)
    }
    module.hot.accept("./loginForm.vue?vue&type=template&id=080b9b94&scoped=true&", function () {
      api.rerender('080b9b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/loginForm.vue"
export default component.exports